import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Mission } from '../components/Mission';
import { HowItWorks } from '../components/HowItWorks';
import { WhoItsFor } from '../components/WhoItsFor';
import { WhyItMatters } from '../components/WhyItMatters';
import { SupportResources } from '../components/SupportResources';
import { PartnerForm } from '../components/PartnerForm';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white text-[#2D2D2D] font-sans selection:bg-[#3D5A4C] selection:text-white" data-id="element-170">
      <Header data-id="element-171" />
      <main data-id="element-172">
        <Hero data-id="element-173" />
        <Mission data-id="element-174" />
        <HowItWorks data-id="element-175" />
        <WhoItsFor data-id="element-176" />
        <WhyItMatters data-id="element-177" />
        <SupportResources data-id="element-178" />
        <PartnerForm data-id="element-179" />
      </main>
      <Footer data-id="element-180" />
    </div>;
}